import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsNotificationsAssociateRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-notifications-associate',
	path: '/secure/project/SelectProjectScheme!default.jspa',
};
